import firebase from 'firebase'
import { airtableConfig } from '@/config.js'
const base = airtableConfig.base

export const employee = {
  state: {
    employees: []
  },
  mutations: {
    addEmployee (state, payload) {
      state.employees = state.employees.concat(payload)
    },
    setEmployees (state, payload) {
      state.employees = payload
    },
    updateEmployee (state, payload) {
      state.employees = state.employees.filter(e => e.id !== payload.id)
      state.employees = state.employees.concat([ payload ])
    }
  },
  actions: {
    addEmployee ({ commit }, payload) {
      return commit('addEmployee', payload)
    },
    setEmployees ({ commit }, payload) {
      return commit('setEmployees', payload)
    },
    async updateEmployeeAvatar ({ commit, dispatch }, payload) {
      const updateAvatar = firebase.functions().httpsCallable('updateEmployeeAvatar')
      await updateAvatar({
        base: base,
        employee: payload.employee
      })
      await setTimeout(async () => {
        const updatedEmployeeResult = await dispatch('getRecords', {
          table: 'Employees',
          view: 'All Employees',
          filter: {
            search: payload.employee.fields.Email,
            field: 'Email'
          }
        })
        console.log(updatedEmployeeResult)
        const updatedEmployee = updatedEmployeeResult[0]
        return commit('updateEmployee', updatedEmployee)
      }, 30000)
    }
  },
  getters: {
    getEmployees (state) {
      return state.employees
    }
  }
}
